module.exports = __webpack_public_path__ + "07d57c96.png";